var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_5711)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6752 6.19188L17.8677 6.40824L13.8871 7.47483L14.2909 8.98195L20.5861 7.29517L18.8993 1L17.3922 1.40383L18.2613 4.64742L18.6752 6.19188Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3239 2.55414C7.0961 2.55414 2.85815 6.79209 2.85815 12.0199L4.43583 12.0198C4.43583 7.66328 7.96746 4.13166 12.3239 4.13166C14.4849 4.13166 16.443 5.00064 17.8677 6.40824L18.6752 6.19188L18.2613 4.64742C16.6375 3.33803 14.5722 2.55414 12.3239 2.55414Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.72807 17.5918L5.9206 17.8081L6.33443 19.3526C5.63513 18.7887 5.0177 18.1273 4.5028 17.3891L6.53016 17.3891C6.59492 17.4578 6.6609 17.5254 6.72807 17.5918Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2719 21.4459C17.4996 21.4459 21.7376 17.2079 21.7376 11.9801L20.1599 11.9802C20.1599 16.3367 16.6283 19.8683 12.2718 19.8683C10.1108 19.8683 8.15277 18.9994 6.72807 17.5918L5.9206 17.8081L6.33443 19.3526C7.95823 20.662 10.0235 21.4459 12.2719 21.4459Z",
    fill: "#FA1E4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5028 17.3891L6.53016 17.3891C6.59492 17.4578 6.6609 17.5254 6.72807 17.5918L10.7086 16.5252L10.3048 15.018L4.00965 16.7048L5.69643 23L7.20355 22.5962L6.33443 19.3526C5.63513 18.7887 5.0177 18.1273 4.5028 17.3891Z",
    fill: "#FA1E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_5711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.8794,
    height: 22,
    fill: "white",
    transform: "translate(2.85815 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.aaaef5b2656c4bc2d523229fde704bb6.svg";
export { ForwardRef as ReactComponent };